import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from 'components/card';
import TimelineItem from 'components/dataDisplay/TimelineItem';
import useCalendarData from 'hooks/useCalendarData';

const TimeLine = () => {
    const { isLoading, events } = useCalendarData();
    const navigate = useNavigate();

    const weeklyTimeline = useMemo(() => {
        const today = new Date();
        const currentDay = today.getDay();
        const diff = currentDay === 0 ? -6 : 1 - currentDay;
        const monday = new Date(today);
        monday.setDate(today.getDate() + diff);

        const weekPlaceholders = Array.from({ length: 5 }).map((_, i) => {
            const date = new Date(monday);
            date.setDate(monday.getDate() + i);
            return {
                weekday: date.toLocaleDateString('en-US', { weekday: 'long' }),
                date: date,
                day: date.getDate(),
            };
        });

        return weekPlaceholders.map((placeholder) => {
            const matchedEvent = events.find(event => 
                new Date(event.start).toDateString() === placeholder.date.toDateString()
            );

            if (matchedEvent) {
                return {
                    id: matchedEvent.id,
                    title: matchedEvent.title,
                    day: placeholder.day,
                    weekday: placeholder.weekday,
                    hasEvent: true,
                    isCurrentDay: today.toDateString() === placeholder.date.toDateString(),
                };
            } else {
                return {
                    id: placeholder.weekday,
                    title: "No events scheduled",
                    day: placeholder.day,
                    weekday: placeholder.weekday,
                    hasEvent: false,
                    isCurrentDay: today.toDateString() === placeholder.date.toDateString(),
                };
            }
        });
    }, [events]);

    const handleViewEvent = (eventId) => {
        const event = events.find(e => e.id === eventId);
        if (event) {
            const eventDate = new Date(event.start).toISOString().split('T')[0];
            navigate(`/admin/calendar?date=${eventDate}`);
        }
    };

    return (
        <Card extra={"w-full p-4 md:p-6"}>
            <div className="mb-5">
                <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                    This Week's Timeline
                </h4>
                <p className="mt-1 text-sm font-medium text-gray-600">
                    A summary of your key activities.
                </p>
            </div>
            <div className="space-y-4">
                {isLoading ? (
                    <p className="text-gray-500">Loading timeline...</p>
                ) : (
                    weeklyTimeline.map((item, index) => (
                        <TimelineItem
                            key={index}
                            title={item.title}
                            day={item.day}
                            weekday={item.weekday}
                            hasEvent={item.hasEvent}
                            isCurrentDay={item.isCurrentDay}
                            onViewClick={item.hasEvent ? () => handleViewEvent(item.id) : null}
                        />
                    ))
                )}
            </div>
        </Card>
    );
};

export default TimeLine;